import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router';

import { selectUserAuthStatus } from '../../../accounts/selectors/user-auth-status.selector.ts';
import { DefaultPathEnum } from '../../../main/constants/default-path.ts';
import { useAppSelector } from '../../../main/hooks/use-app-selector.ts';

interface Props {
  children: ReactNode;
}

export const PublicScreenProtector: FC<Props> = ({ children }) => {
  const isAuthenticated = useAppSelector(selectUserAuthStatus);

  if (isAuthenticated) {
    return <Navigate to={DefaultPathEnum.HOME_SCREEN} replace={true} />;
  }

  return children;
};
